"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(["\n    display: inline-block;\n    text-decoration: inherit;\n    line-height: ", "em;\n"], ["\n    display: inline-block;\n    text-decoration: inherit;\n    line-height: ", "em;\n"]);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require("react-router-dom");

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _index = require("../index");

var _theme = require("../theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ButtonLink = _index.Button.withComponent(_reactRouterDom.Link).extend(_templateObject, function (props) {
    return _theme.sizes[props.size];
});

ButtonLink.displayName = "ButtonLink";

exports.default = ButtonLink;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/buttonLink.js
// module id = 990
// module chunks = 95715928098905 168707334958949